import React, { createContext, useContext, useState, useEffect } from 'react';

interface LivesContextType {
  lives: number;
  addLives: (amount: number) => void;
  resetLives: () => void;
}

const LivesContext = createContext<LivesContextType>({
  lives: 0,
  addLives: () => {},
  resetLives: () => {},
});

export const useLives = () => useContext(LivesContext);

export const LivesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lives, setLives] = useState<number>(0);

  // Load lives from localStorage on mount
  useEffect(() => {
    const savedLives = localStorage.getItem('userLives');
    if (savedLives) {
      setLives(parseInt(savedLives, 10));
    }
  }, []);

  const addLives = (amount: number) => {
    const newLives = lives + amount;
    setLives(newLives);
    localStorage.setItem('userLives', newLives.toString());
  };

  const resetLives = () => {
    setLives(0);
    localStorage.removeItem('userLives');
  };

  return (
    <LivesContext.Provider value={{ lives, addLives, resetLives }}>
      {children}
    </LivesContext.Provider>
  );
}; 